import axios from '@app/config/axios.config';
import { getTablesParams } from '../apiType';
import { Mandat } from './mandats';
import { User } from './users';

export enum ParrainagesReconductionsStatus {
    A_traiter = 'A_traiter',
    Ne_pas_appeler = 'Ne_pas_appeler',
    Refus = 'Refus',
    Rappeler = 'Rappeler',
    Sans_reponse = 'Sans_reponse',
    Doc_envoyee = 'Doc_envoyee',
    Parrainage = 'Parrainage',
}

export type ParrainagesReconductions = {
    id: number;
    createdAt: string;
    updatedAt: string;
    status: ParrainagesReconductionsStatus;
    raisonSociale: string;
    titre: string;
    prenom1: string;
    nom1: string;
    prenom2: string;
    nom2: string;
    adresse: string;
    cp: string;
    numeroPostal: string;
    localite: string;
    telephone1: string;
    telephone2: string;
    raisonSocialePj: string;
    libelleFacture: string;
    correspondance: string;
    accordDe: string;
    dateAccord: string;
    email: string;
    infosInternes: string;
    publicite: string;
    reconduction: boolean;
    annonceOk: boolean;
    ca: number;
    noClub: string;
    validated: boolean;
    collaborateur: User;
    mandat: Mandat;
    POTENTIEL_MODIFIE: boolean;
    BDD_OK: boolean;
};

export const getParrainagesReconductions = async (
    params: getTablesParams
): Promise<{
    result: ParrainagesReconductions[];
    totalCount: number;
    aggregate: any;
}> => {
    try {
        const res = await axios.get('/parrainages-reconductions', { params });
        return res.data;
    } catch (err) {
        console.error(err);
        return { result: [], totalCount: 0, aggregate: null };
    }
};

export const getParrainagesReconductionsById = async (id: string) => {
    return await axios.get(`/parrainages-reconductions/${id}`);
};

export interface CreateParrainagesReconductionsBody {
    status?: ParrainagesReconductionsStatus;
    raisonSociale?: string;
    titre?: string;
    prenom1?: string;
    nom1?: string;
    prenom2?: string;
    nom2?: string;
    adresse?: string;
    cp?: string;
    numeroPostal?: string;
    localite?: string;
    telephone1?: string;
    telephone2?: string;
    raisonSocialePj?: string;
    libelleFacture?: string;
    correspondance?: string;
    accordDe?: string;
    dateAccord?: string;
    email?: string;
    infosInternes?: string;
    publicite?: string;
    reconduction?: boolean;
    annonceOk?: boolean;
    ca?: number;
    noClub?: string;
    validated?: boolean;
    collaborateur?: string;
}

export const createParrainagesReconductions = async (
    body: CreateParrainagesReconductionsBody
) => {
    return await axios.post(`/parrainages-reconductions`, body);
};

export const updateParrainagesReconductions = async (
    id: string,
    body: CreateParrainagesReconductionsBody
) => {
    return await axios.patch(`/parrainages-reconductions/${id}`, body);
};

export const markAsProcessed = async (id: string) => {
    return await axios.post(`/parrainages-reconductions/${id}/process`);
};

export const validateReconductionsNonRenouvelees = async (
    reconductionIds: number[]
) => {
    return await axios.post('/parrainages-reconductions/validate-non-renouvelees', {
        reconductionIds,
    });
};